module.exports = __webpack_public_path__ + "img/8b7aa0826b1ffaf12704713832553e69.png";